<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <div class="d-flex flex-row" style="width: 100%">
        <div style="width: 70%">
          <h1><strong>Chi tiết phiếu duyệt chi nhánh mới</strong></h1>
        </div>
        <div style="width: 30%" class="text-right">
          <button
            type="button"
            v-if="checkPermission && checkConfirmChange(info.status)"
            @click="showStatusModal('CONFIRMED_CHANGE')"
            class="btn bg-yellow btn-outline-dark hc-37 mr-2 pt-2"
          >
            Xác nhận sửa
          </button>
          <button
            type="button"
            v-if="checkPermission && checkRequestChange(info.status)"
            @click="showStatusModal('REQUEST_CHANGE')"
            class="btn btn-warning btn-outline-dark hc-37 mr-2 pt-2"
          >
            Yêu cầu sửa
          </button>
          <button
            type="button"
            v-if="checkPermission && checkApprove(info.status)"
            @click="showStatusModal('APPROVED')"
            class="btn btn-primary btn-outline-dark hc-37 mr-2 pt-2"
          >
            Duyệt
          </button>
          <button
            type="button"
            v-if="checkPermission && checkReject(info.status)"
            @click="showStatusModal('REJECTED')"
            class="btn btn-danger btn-outline-dark hc-37 mr-2 pt-2"
          >
            Từ chối
          </button>
          <button
            type="button"
            @click="ReturnToList"
            class="btn btn-outline-secondary hc-37 mr-2 pt-2"
          >
            <i class="bx bx-arrow-back"></i>
            <span>&nbsp;</span>Quay lại
          </button>
        </div>
      </div>
    </div>

    <b-card>
      <b-row class="gx-2">
        <b-col cols="10" md="5">
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Thông tin phiếu</strong>
            </h1>
            <template v-if="!isLoading">
              <template v-if="info">
                <div class="form-group form-row border-store">
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Mã phiếu:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>
                        {{ info.code }}
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Mã hợp đồng/ PLHĐ:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>
                        <strong
                          class="text-info"
                          style="cursor: pointer"
                          @click="toContractDetail(info?.contractId)"
                          >{{ info.contractCode }}</strong
                        >
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Người đề xuất:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>{{ info.creator?.name }}</p>
                      <p>{{ info.creator?.email }}</p>
                    </div>
                  </div>
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Ngày tạo:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>
                        {{ info.createdTime | formatDate }}
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Trạng thái phiếu:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>
                        <span v-if="info.status" :class="`badge ${getStatusClass(info.status)}`">
                          {{ getStatusName(info.status) }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Thông tin merchant</strong>
            </h1>
            <template v-if="!isLoading">
              <template v-if="info">
                <div class="form-group form-row border-store">
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Tên merchant account:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>
                        {{ info.merchantName }}
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Email:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>{{ info.merchantEmail }}</p>
                    </div>
                  </div>
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Địa chỉ:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>
                        {{ getAdressByCode(info) }}
                      </p>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>

          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Thông tin cửa hàng</strong>
              <strong
                v-if="info?.storeRes?.merchantOwnerId && info?.storeRes?.ownerName"
                class="text-primary pt-1"
                style="cursor: pointer; float: right; font-size: small"
                @click="toStoreList(info?.storeRes)"
                >Quản lý cửa hàng</strong
              >
            </h1>
            <template v-if="!isLoading">
              <template v-if="info.storeRes">
                <div class="form-group form-row border-store">
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Tên cửa hàng:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>
                        <strong
                          class="text-info"
                          style="cursor: pointer"
                          @click="toStoreDetail(info?.storeId)"
                          >{{ info.storeRes.storeName }}</strong
                        >
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Địa chỉ:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>
                        {{ getAdressByCode(info.storeRes) }}
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 border-row">
                    <label for="" class="col-sm-4 col-form-label">
                      <p class="float-left">Vị trí:</p>
                    </label>
                    <div class="col-sm-8">
                      <p>
                        <strong
                          class="text-primary"
                          style="cursor: pointer"
                          @click="
                            showMapModal(
                              info.storeRes.latitude,
                              info.storeRes.longitude,
                              getAdressByCode(info.storeRes)
                            )
                          "
                          >{{ info.storeRes.address }}</strong
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Thiết bị</strong>
            </h1>
            <template v-if="!isLoading">
              <b-table
                bordered
                hover
                head-variant="light"
                fixed
                show-empty
                responsive
                sticky-header
                :items="info.devices"
                :fields="devicesFields"
                :busy.sync="isLoading"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
                <template #empty>
                  <div class="text-center text-info my-2">Không có dữ liệu</div>
                </template>
                <template #emptyfiltered="{ emptyFilteredText }">
                  <h4>{{ emptyFilteredText }}</h4>
                </template>
                <template #cell(index)="{ index }">
                  {{ index + 1 }}
                </template>
              </b-table>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Lịch sử xác nhận phiếu</strong>
            </h1>
            <template v-if="!isLoading">
              <b-table
                bordered
                hover
                head-variant="light"
                fixed
                show-empty
                responsive
                sticky-header
                :items="info.logs"
                :fields="logsFields"
                :busy.sync="isLoading"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
                <template #empty>
                  <div class="text-center text-info my-2">Không có dữ liệu</div>
                </template>
                <template #emptyfiltered="{ emptyFilteredText }">
                  <h4>{{ emptyFilteredText }}</h4>
                </template>
                <template #cell(createdTime)="{ value }">
                  {{ value | formatDate('HH:mm DD/MM/YYYY') }}
                </template>
                <template #cell(type)="{ value }">
                  {{ getTypeName(value) }}
                </template>
                <template #cell(creator)="{ item }">
                  <div>{{ item?.creator?.name }}</div>
                  <div>{{ item?.creator?.email }}</div>
                </template>
              </b-table>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
        </b-col>
        <b-col cols="10" md="5">
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Ảnh chi nhánh</strong>
            </h1>
            <template v-if="!isLoading">
              <template v-if="info?.storeRes?.images">
                <div class="img-list">
                  <ul v-viewer class="m-0">
                    <li
                      class="p-1 item-img"
                      v-for="(item, index) in info?.storeRes?.images"
                      :key="index"
                    >
                      <a href="javascript:void(0)">
                        <img :src="item" />
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- <div class="d-flex">
                  <div class="px-md-3" v-for="img in info.storeRes.images" :key="img">
                    <b-img :src="img" height="200" width="200" fluid rounded thumbnail @click="showImage(img)"
                      style="cursor: pointer;"></b-img>
                  </div>
                </div> -->
              </template>
              <template v-else>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Ảnh giấy tờ xác minh</strong>
            </h1>
            <template v-if="!isLoading">
              <template v-if="info?.storeRes?.verificationImage">
                <div class="img-list">
                  <ul v-viewer class="m-0">
                    <li
                      class="p-1 item-img"
                      v-for="(item, index) in info?.storeRes?.verificationImage"
                      :key="index"
                    >
                      <a href="javascript:void(0)">
                        <img :src="item" />
                      </a>
                    </li>
                  </ul>
                </div>

                <!-- <div class="d-flex">
                  <div class="px-md-3" v-for="imgvef in info?.storeRes?.verificationImage" :key="imgvef">
                    <b-img :src="imgvef" height="200" width="200" fluid rounded thumbnail @click="showImage(imgvef)"
                      style="cursor: pointer;"></b-img>
                  </div>
                </div> -->
              </template>
              <template v-else>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-modal ref="modal-map" centered hide-footer hide-header size="lg" style="z-index: 500">
      <div>
        <GmapMap
          :center="{ lat: latitude, lng: longtitude }"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; height: 500px"
        >
          <gmap-marker :position="{ lat: latitude, lng: longtitude }"></gmap-marker>
        </GmapMap>
      </div>
    </b-modal>
    <b-modal ref="map-address" centered hide-footer hide-header size="lg" style="z-index: 500">
      <div>
        <iframe loading="lazy" :src="url" height="500" style="width: 100%" frameborder="0"></iframe>
      </div>
    </b-modal>
    <b-modal id="imageModal" title="Hình ảnh" size="lg" hide-footer>
      <img :src="imageSrc" class="img-fluid" alt="Hình ảnh đầy đủ kích thước" />
    </b-modal>
    <b-modal
      id="statusModal"
      ref="statusModal"
      :title="title"
      @ok="submitForm"
      @cancel="cancelForm"
      @hide="cancelForm"
      @hidden="resetNoteState"
      :ok-title="['APPROVED', 'REJECTED'].includes(selectedStatus) ? 'Đồng ý' : 'Lưu'"
      cancel-title="Hủy"
    >
      <b-form @submit.prevent="submitForm">
        <!-- Ghi chú -->
        <template v-if="selectedStatus == 'APPROVED'">
          <h3 class="text-center">Bạn chắc chắn muốn duyệt phiếu yêu cầu?</h3>
        </template>
        <template v-else-if="selectedStatus == 'CONFIRMED_CHANGE'">
          <h3 class="text-center">Bạn xác nhận muốn sửa phiếu yêu cầu?</h3>
        </template>
        <template v-else-if="selectedStatus == 'REJECTED'">
          <h3 class="text-center" style="padding-bottom: 5px">
            Bạn chắc chắn muốn từ chối phiếu yêu cầu?
          </h3>
          <b-form-group>
            <b-form-textarea
              id="noteTextarea"
              v-model="note"
              placeholder="Nhập ghi chú (tùy chọn)"
              rows="3"
              :required="isNoteRequired"
              :class="{ 'is-invalid': isInvalid }"
            ></b-form-textarea>
            <b-form-invalid-feedback v-if="isInvalid">
              Vui lòng nhập ghi chú.
            </b-form-invalid-feedback>
          </b-form-group>
        </template>
        <template v-else>
          <b-form-group label="Ghi chú" label-for="noteTextarea">
            <b-form-textarea
              id="noteTextarea"
              v-model="note"
              placeholder="Nhập ghi chú (tùy chọn)"
              rows="3"
              :required="isNoteRequired"
              :class="{ 'is-invalid': isInvalid }"
            ></b-form-textarea>
            <b-form-invalid-feedback v-if="isInvalid">
              Vui lòng nhập ghi chú.
            </b-form-invalid-feedback>
          </b-form-group>
        </template>
      </b-form>
    </b-modal>
    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import {
    Detail,
    ConfirmChange,
    SaApprove,
    SaReject,
    SaRequestChange,
    VhApprove,
    VhReject,
    VhRequestChange,
  } from '@/services/customer-support/order-store'
  import { showMess } from '@/config/utils'
  import { CommonService } from '@/services/common.service'
  // import moment from 'moment'
  export default {
    components: {},
    data() {
      return {
        isOpen: false,
        isLoading: false,
        isLoadingContract: false,
        latitude: 0.0,
        longitude: 0.0,
        url: '',
        imageSrc: '',
        id: '',
        noteState: null,
        isInvalid: false, // Trạng thái lỗi
        info: {},
        maInfo: {},
        moInfo: {},
        keyNames: [
          { key: 'contractCode', label: 'Mã hợp đồng/ PLHĐ' },
          { key: 'creator', label: 'Người đề xuất' },
          { key: 'createdTime', label: 'Ngày tạo' },
          { key: 'status', label: 'Trạng thái phiếu' },
        ],

        listStatus: [
          { id: 0, text: 'Tất cả' },
          {
            id: 'PENDING_SA_APPROVAL',
            text: 'Chờ SA duyệt',
            name: 'Chờ SA duyệt',
            bgColor: 'badge-warning',
            class: 'text-warning',
          },
          {
            id: 'PENDING_VH_APPROVAL',
            text: 'Chờ VH duyệt',
            name: 'Chờ VH duyệt',
            bgColor: 'badge-warning',
            class: 'text-warning',
          },
          {
            id: 'SA_REQUESTED_CHANGES',
            text: 'SA yêu cầu sửa',
            name: 'SA yêu cầu sửa',
            bgColor: 'badge-info',
            class: 'text-info',
          },
          {
            id: 'VH_REQUESTED_CHANGES',
            text: 'VH yêu cầu sửa',
            name: 'VH yêu cầu sửa',
            bgColor: 'badge-info',
            class: 'text-info',
          },
          {
            id: 'SA_REJECTED',
            text: 'SA từ chối',
            name: 'SA từ chối',
            bgColor: 'badge-danger',
            class: 'text-danger',
          },
          {
            id: 'VH_REJECTED',
            text: 'VH từ chối',
            name: 'VH từ chối',
            bgColor: 'badge-danger',
            class: 'text-danger',
          },
          {
            id: 'SUCCESS',
            text: 'VH duyệt',
            name: 'VH duyệt',
            bgColor: 'badge-success',
            class: 'text-success',
          },
        ],
        listType: [
          { id: 'NEW', text: 'Tạo mới' },
          { id: 'UPDATE', text: 'Sửa đổi thông tin' },
          { id: 'SA_APPROVED', text: 'SA duyệt' },
          { id: 'VH_APPROVED', text: 'VH duyệt' },
          { id: 'SA_REQUESTED_CHANGES', text: 'SA yêu cầu sửa' },
          { id: 'VH_REQUESTED_CHANGES', text: 'VH yêu cầu sửa' },
          { id: 'SA_REJECTED', text: 'SA từ chối' },
          { id: 'VH_REJECTED', text: 'VH từ chối' },
          { id: 'SA_REJECTED_CONTRACT', text: 'SA từ chối hợp đồng' },
          { id: 'SUCCESS', text: 'Hoàn thành' },
        ],
        devicesFields: [
          {
            key: 'index',
            label: 'STT',
            class: 'text-center',
            thStyle: 'width: 20px; text-align: center',
          },
          {
            key: 'categoryName',
            label: 'Tên',
            sortable: false,
            class: 'text-center',
          },
          {
            key: 'serial',
            label: 'Mã serial',
            sortable: false,
            class: 'text-center',
          },
        ],
        logsFields: [
          {
            key: 'createdTime',
            label: 'Thời gian',
            class: 'time_class text-center',
            thStyle: 'width: 120px; text-align: center',
          },
          {
            key: 'creator',
            label: 'Người xác nhận',
            sortable: false,
            class: 'text-center',
          },
          {
            key: 'type',
            label: 'Loại hoạt động',
            sortable: false,
            class: 'time_class text-center',
          },
          {
            key: 'message',
            label: 'Lý do',
            sortable: false,
            class: 'text-center',
          },
        ],
        contact: [],
        regionCode: '',
        provinceCode: '',
        districtCode: '',
        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        selectedStatus: '',
        note: '',
        title: '',
        noteTitle: {
          CONFIRMED_CHANGE: 'Xác nhận đã sửa phiếu',
          REQUEST_CHANGE: 'Yêu cầu sửa phiếu',
          APPROVED: 'Duyệt phiếu',
          REJECTED: 'Từ chối phiếu',
        },
      }
    },

    filters: {},

    async created() {
      this.id = this.$router.currentRoute.params.id
      // await this.configSystem()
    },

    mounted() {
      if (this.dataPermission.includes('CNPS_CSS_ORDER_STORE_VIEW')) {
        this.toggleSideBar()
        this.loadData()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            // size: 'sm',
            // buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(value => {
            // chuyển trang
            this.$router.replace('/')
          })
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      getStatusName() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },
      getTypeName() {
        return type => {
          const objType = this.listType.find(s => s.id === type)
          return objType ? objType.text : type
        }
      },
      checkRequestChange() {
        return status => {
          const objStatus = ['PENDING_SA_APPROVAL', 'PENDING_VH_APPROVAL']
          return objStatus.includes(status)
        }
      },
      checkConfirmChange() {
        return status => {
          const objStatus = ['SA_REQUESTED_CHANGES', 'VH_REQUESTED_CHANGES']
          return objStatus.includes(status)
        }
      },
      checkApprove() {
        return status => {
          const objStatus = ['PENDING_SA_APPROVAL', 'PENDING_VH_APPROVAL']
          return objStatus.includes(status)
        }
      },
      checkReject() {
        return status => {
          const objStatus = ['PENDING_SA_APPROVAL', 'PENDING_VH_APPROVAL']
          return objStatus.includes(status)
        }
      },
      isNoteRequired() {
        return this.selectedStatus === 'REQUEST_CHANGE' || this.selectedStatus === 'REJECTED'
      },
      checkPermission() {
        return (
          this.dataPermission.includes('CNPS_CSS_ORDER_STORE_CONFIRM_CHANGE') ||
          this.dataPermission.includes('CNPS_CSS_ORDER_STORE_PERMISSION_SA') ||
          this.dataPermission.includes('CNPS_CSS_ORDER_STORE_PERMISSION_VH')
        )
      },
    },

    methods: {
      ReturnToList() {
        this.$router.push(`/customer-support/order-store`)
      },
      toContractDetail(contractId) {
        this.$router.push(`/contract-detail-ecommerce/${contractId}`)
      },
      toStoreDetail(storeId) {
        this.$router.push(`/customer-support/store/${storeId}`)
      },
      toStoreList(storeData) {
        window.open(
          `/customer-support/store/?moId=${storeData?.merchantOwnerId}&moName=${storeData?.ownerName}&status=ACTIVE`,
          '_blank'
        )
        // this.$router.push(`/customer-support/store?keyword=${keyword}`)
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await Detail({ id: this.id })
          this.info = res.data
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
      setActive(id) {
        this.activeItem = id
      },
      toggleSideBar() {
        this.$store.commit('dom/SET_SIDEBAR_STATUS', !this.isOpen)
      },
      showMapModal(lat, long, address) {
        if (lat && long) {
          this.latitude = Number.isInteger(this.latitude) ? lat : parseFloat(lat)
          this.longtitude = Number.isInteger(this.longtitude) ? long : parseFloat(long)
          this.$refs['modal-map'].show()
        } else {
          this.url = `https://maps.google.com/maps?q=${address}&output=embed`
          this.$refs['map-address'].show()
        }
      },
      showImage(img) {
        this.imageSrc = img
        this.$bvModal.show('imageModal')
      },
      getAdressByCode(item) {
        const addressArr = []
        if (item.districtName) {
          addressArr.push(item.districtName)
        }
        if (item.provinceName) {
          addressArr.push(item.provinceName)
        }
        if (item.regionName) {
          addressArr.push(item.regionName)
        }
        return addressArr.length > 0 ? addressArr.join(', ') : item.address
      },
      showStatusModal(status) {
        const permissionArr = [
          'CNPS_CSS_ORDER_STORE_CONFIRM_CHANGE',
          'CNPS_CSS_ORDER_STORE_PERMISSION_SA',
          'CNPS_CSS_ORDER_STORE_PERMISSION_VH',
        ]
        if (permissionArr.some(item => this.dataPermission.includes(item))) {
          this.selectedStatus = status
          this.title = this.noteTitle[status]
          this.$bvModal.show('statusModal')
        } else {
          this.$bvModal
            .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
              title: 'Cảnh báo',
              okVariant: 'danger',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true,
            })
            .then(() => {
              this.isLoading = false
            })
        }
      },
      async submitForm(evt) {
        evt.preventDefault()
        if (this.isNoteRequired && !this.note) {
          this.isInvalid = true
        } else {
          this.isInvalid = false
          this.isLoading = true
          if (
            this.dataPermission.includes('CNPS_CSS_ORDER_STORE_CONFIRM_CHANGE') ||
            this.dataPermission.includes('CNPS_CSS_ORDER_STORE_PERMISSION_VH') ||
            this.dataPermission.includes('CNPS_CSS_ORDER_STORE_PERMISSION_SA')
          ) {
            let param = {}
            switch (this.selectedStatus) {
              case 'CONFIRMED_CHANGE':
                param = {
                  id: this.id,
                }
                try {
                  const response = await ConfirmChange(param)
                  this.note = ''
                  if (response && response.result) {
                    this.loadData()
                  } else {
                    showMess(
                      this,
                      'Error',
                      response.message,
                      'danger',
                      'b-toaster-top-right',
                      5 * 60 * 60
                    )
                  }
                } catch (error) {
                  showMess(
                    this,
                    'Error',
                    error.message,
                    'danger',
                    'b-toaster-top-right',
                    5 * 60 * 60
                  )
                } finally {
                  this.note = ''
                }
                break
              case 'REQUEST_CHANGE':
                param = {
                  id: this.id,
                  note: this.note,
                }
                try {
                  let response
                  if (this.info.status == 'PENDING_SA_APPROVAL') {
                    response = await SaRequestChange(param)
                  } else if (this.info.status == 'PENDING_VH_APPROVAL') {
                    response = await VhRequestChange(param)
                  }
                  this.note = ''
                  if (response && response.result) {
                    this.loadData()
                  } else {
                    showMess(
                      this,
                      'Error',
                      response.message,
                      'danger',
                      'b-toaster-top-right',
                      5 * 60 * 60
                    )
                  }
                } catch (error) {
                  showMess(
                    this,
                    'Error',
                    error.message,
                    'danger',
                    'b-toaster-top-right',
                    5 * 60 * 60
                  )
                } finally {
                  this.note = ''
                }
                break
              case 'REJECTED':
                param = {
                  id: this.id,
                  note: this.note,
                }
                try {
                  let response
                  if (this.info.status == 'PENDING_SA_APPROVAL') {
                    response = await SaReject(param)
                  } else if (this.info.status == 'PENDING_VH_APPROVAL') {
                    response = await VhReject(param)
                  }
                  this.note = ''
                  if (response && response.result) {
                    this.loadData()
                  } else {
                    showMess(
                      this,
                      'Error',
                      response.message,
                      'danger',
                      'b-toaster-top-right',
                      5 * 60 * 60
                    )
                  }
                } catch (error) {
                  showMess(
                    this,
                    'Error',
                    error.message,
                    'danger',
                    'b-toaster-top-right',
                    5 * 60 * 60
                  )
                } finally {
                  this.note = ''
                }
                break

              case 'APPROVED':
                param = {
                  id: this.id,
                }
                try {
                  let response
                  if (this.info.status == 'PENDING_SA_APPROVAL') {
                    response = await SaApprove(param)
                  } else if (this.info.status == 'PENDING_VH_APPROVAL') {
                    response = await VhApprove(param)
                  }
                  this.note = ''
                  if (response && response.result) {
                    this.loadData()
                  } else {
                    showMess(
                      this,
                      'Error',
                      response.message,
                      'danger',
                      'b-toaster-top-right',
                      5 * 60 * 60
                    )
                  }
                } catch (error) {
                  showMess(
                    this,
                    'Error',
                    error.message,
                    'danger',
                    'b-toaster-top-right',
                    5 * 60 * 60
                  )
                } finally {
                  this.note = ''
                }
                break

              default:
                console.log('Vui lòng chọn trạng thái hợp lệ')
            }
          } else {
            this.$bvModal.msgBoxOk('Bạn không có quyền truy cập vào trang này', {
              title: 'Cảnh báo',
              // size: 'sm',
              // buttonSize: 'sm',
              okVariant: 'danger',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true,
            })
          }
          this.$bvModal.hide('statusModal')
        }
      },
      cancelForm() {
        this.note = ''
      },
      resetNoteState() {
        this.isInvalid = false // Reset trạng thái của ghi chú khi modal bị đóng
      },
    },
    // lấy ngành hàng và dịch vụ
    configSystem() {
      return CommonService.getConfigSystem()
        .then(data => {
          if (data.success) {
            this.maContact = data.data.maContact.map(item => {
              return {
                id: item.code,
                text: item.name,
              }
            })
            this.moContact = data.data.moContact.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.storeContact = data.data.storeContact.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
          }
        })
        .catch(error => console.error(error))
    },
  }
</script>

<style scoped>
  .is-invalid {
    border-color: #dc3545;
    /* Đỏ cho input không hợp lệ */
  }

  .breadcrumb {
    margin-bottom: 0;
  }

  .card-footer {
    background-color: #fff;
    border-top: none !important;
  }

  .box {
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  ul.report-preview {
    padding-left: 0;
    display: flex;

    li {
      border: 1px solid #ddd;
      border-radius: 5px;
      width: 100px;
      min-width: 100px;
      height: 60px;
      cursor: pointer;
      /* text-align: center; */
      padding: 10px;

      &:hover {
        color: #f00;
        font-weight: 500;
      }

      .label {
        font-size: 14px;
        text-align: center;
      }

      .value {
        text-align: center;
        margin-top: 2px;
        font-size: 16px;
        font-weight: 600;
      }

      & + li {
        margin-left: 10px;
      }
    }
  }

  .spinner-center {
    display: flex;
    justify-content: center;
  }

  h1 {
    border-bottom: none;
  }

  .h1-strong {
    border-left: 3px solid #13569f;
    padding-left: 5px;
    font-size: larger;
  }

  .img_logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #ddd;
  }

  .btn-class {
    background-color: #edf6ff;
  }

  .btn-class:hover {
    background-color: #007bff;
  }

  .inner_menu {
    border-right: 1px solid #edf1fa;
  }

  .menu_li:hover {
    background-color: #268dfc;
    color: #fff;
    cursor: pointer;
  }

  .border-row {
    border-bottom: 2px dashed #edf1fa;
    display: flex;
  }

  .border-store {
    border-top: 1px solid #a7a7a7;
  }
</style>
<style>
  .time_class {
    min-width: 120px;
    max-width: 150px;
  }

  .store_class {
    padding-bottom: 5px;
  }

  .b-table-sticky-header {
    min-height: 20vh;
  }
</style>
